import React from 'react';
import { AccountHolderApi } from 'common/types';
import { Box } from '@mui/material';
import { StatusChip } from 'common/components/display/StatusChip';
import FlexBox from 'common/components/FlexBox';
import { useTranslation } from 'services/localization';
import { PaymentOnboardButton } from './PaymentOnboardButton';

interface Props {
	account: AccountHolderApi;
}

export const RentlePaymentsStatus = ({ account }: Props) => {
	const { t } = useTranslation();
	const { accountHolderStatus } = account;
	const accountActive = accountHolderStatus.status === 'Active';
	const accountError =
		accountHolderStatus.status === 'Closed' || accountHolderStatus.status === 'Suspended';
	const payoutEnabled = accountHolderStatus.payoutState.allowPayout;

	return (
		<Box>
			<Box display="flex" justifyContent="flex-end">
				<PaymentOnboardButton
					text={t('account.payments.viewAccount', 'View account')}
					variant="textSecondary"
					accountHolderCode={account.accountHolderCode}
				/>
			</Box>
			<FlexBox justifyContent="flex-end" textAlign="left">
				<Box mr={0.5}>
					<StatusChip
						title={t('settings.status', 'Status')}
						variant={accountActive ? 'success' : accountError ? 'error' : 'warning'}
						text={
							accountActive
								? t('settings.statusValues.active', 'Active')
								: accountError
								? t('settings.statusValues.inactive', 'Inactive')
								: t('settings.statusValues.pending', 'Pending')
						}
					/>
				</Box>
				<Box>
					<StatusChip
						title={t('account.payments.payouts', 'Payouts')}
						variant={payoutEnabled ? 'success' : 'inactive'}
						text={
							payoutEnabled
								? t('settings.statusValues.active', 'Active')
								: t('settings.statusValues.blocked', 'Blocked')
						}
					/>
				</Box>
			</FlexBox>
		</Box>
	);
};
